<script>
  import CourseCard from './CourseCard.svelte';
  import GridCard from './GridCard.svelte';


  //export let filterUrl;
	export let filteredCourses =[];
  export let customPosts = [];
  export let layout;
  export let cardHeight;
  export let textSize;
  
  
  export let coulmnCount;

  let columncountCSS = {
    "1": "md:grid-cols-1",
    "2": "md:grid-cols-2",
    "3": "md:grid-cols-3",
    "4": "md:grid-cols-4",
    "5": "md:grid-cols-5",
    "6": "md:grid-cols-6",
  }
  let renderedColumnCount = columncountCSS[coulmnCount]
  
</script>

<div class="container carousel-main !px-0 flex flex-col items-center justify-end scrollbar-hide solution relative">
    <!-- Section for customPosts with CourseCard -->
  <div class="solution-list carousel-items scrollbar-hide padding-card-solution overflow-x-scroll grid grid-flow-col gap-5 justify-start snap-x fluid-last">
    {#each customPosts as course}
      <CourseCard course={course} />
    {/each}
 

  {#if layout == "list"} 
    {#each filteredCourses as course}   
      <CourseCard course={course} {textSize}/>     
    {/each} 
  {/if}
</div>

    <!-- Section for filteredCourses with CourseCard -->
    {#if layout == "grid"}
    <div class="teachers-grid-layout grid grid-cols-1 sm:grid-cols-2   gap-5 justify-start {renderedColumnCount}">
      {#each filteredCourses as course}       
          <GridCard course={course} {cardHeight} {textSize}/>       
      {/each}
    </div>
    {/if}
  
</div>


